import React, { useEffect } from 'react';
import { UCHIRU_LINK } from 'shared/constants';
import styles from './OneManySorry.module.scss';
import { ONE_MANY_SORRY_TEXTS } from './constants';
import { sendOneManyMiniSubEvent } from '../OneMany/events';
import { ONE_MANY_KEY, TEXT } from '../OneMany/constants';

export function OneManySorry() {
  useEffect(() => {
    document.title = TEXT.documentTitle;
    sendOneManyMiniSubEvent('SORRY_PAGE');
    localStorage.setItem(ONE_MANY_KEY, 'true');
  }, []);

  const handleClick = () => {
    window.location.assign(UCHIRU_LINK);
    sendOneManyMiniSubEvent('CLICK_MAIN');
  };

  return (
    <div className={styles.oneManySorryWrap}>
      <h1>{ONE_MANY_SORRY_TEXTS.title}</h1>
      <p className={styles.subtitleDesktop}>{ONE_MANY_SORRY_TEXTS.subtitle}</p>
      <p className={styles.subtitleMobile}>{ONE_MANY_SORRY_TEXTS.subtitleMobile}</p>
      <button type="button" onClick={handleClick}>
        {ONE_MANY_SORRY_TEXTS.button}
      </button>
    </div>
  );
}
